import React from 'react';
import LegalPageLayout, { LegalSection, LegalList } from '../components/LegalPageLayout';

const PrivacyPolicy: React.FC = () => (
  <LegalPageLayout title="Privacy Policy" lastUpdated="1 March 2026">
    <LegalSection title="1. Introduction">
      <p>Welcome to Sahayy ("we," "our," or "us"). We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application and related services.</p>
    </LegalSection>

    <LegalSection title="2. Information We Collect">
      <p>We may collect the following types of information:</p>
      <LegalList items={[
        <><strong style={{ color: "#111827" }}>Personal Information:</strong> Name, email address, and profile information you provide when creating an account.</>,
        <><strong style={{ color: "#111827" }}>Usage Data:</strong> Information about how you use our app, including features accessed, time spent, and interaction patterns.</>,
        <><strong style={{ color: "#111827" }}>Device Information:</strong> Device type, operating system, unique device identifiers, and mobile network information.</>,
        <><strong style={{ color: "#111827" }}>Location Data:</strong> With your permission, we may collect location information to provide location-based services.</>,
        <><strong style={{ color: "#111827" }}>Communication Data:</strong> Messages, posts, and other content you share through our platform.</>,
      ]} />
    </LegalSection>

    <LegalSection title="3. How We Use Your Information">
      <p>We use your information to:</p>
      <LegalList items={[
        'Provide, maintain, and improve our services',
        'Create and manage your account',
        'Facilitate communication between users',
        'Send notifications and updates about our services',
        'Analyze usage patterns to enhance user experience',
        'Ensure security and prevent fraud',
        'Moderate content and enforce community guidelines',
        'Process user reports and maintain community safety',
        'Track warnings and enforcement actions for policy violations',
        'Comply with legal obligations',
      ]} />
    </LegalSection>

    <LegalSection title="4. Information Sharing and Disclosure">
      <p>We do not sell, trade, or rent your personal information to third parties. We may share your information in the following circumstances:</p>
      <LegalList items={[
        <><strong style={{ color: "#111827" }}>With Your Consent:</strong> When you explicitly agree to share information</>,
        <><strong style={{ color: "#111827" }}>Service Providers:</strong> With trusted third-party service providers who assist in operating our app</>,
        <><strong style={{ color: "#111827" }}>Legal Requirements:</strong> When required by law or to protect our rights and safety</>,
        <><strong style={{ color: "#111827" }}>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets</>,
      ]} />
    </LegalSection>

    <LegalSection title="5. Data Security">
      <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure.</p>
    </LegalSection>

    <LegalSection title="6. Data Retention">
      <p>We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.</p>
    </LegalSection>

    <LegalSection title="7. Your Rights">
      <p>You have the right to:</p>
      <LegalList items={[
        'Access and review your personal information',
        'Correct inaccurate or incomplete information',
        'Delete your account and personal information',
        'Opt-out of certain communications',
        'Request data portability',
      ]} />
    </LegalSection>

    <LegalSection title="8. International Data Transfers">
      <p>Your information may be transferred to and processed in countries other than your own. We ensure that such transfers comply with applicable data protection laws and implement appropriate safeguards.</p>
    </LegalSection>

    <LegalSection title="9. Changes to This Privacy Policy">
      <p>We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new Privacy Policy on this page and updating the "Last updated" date.</p>
    </LegalSection>

    <LegalSection title="10. Contact Us">
      <p>If you have any questions about this Privacy Policy or our privacy practices, please contact us at:</p>
      <p>Email: <a href="mailto:care@sahayy.com" style={{ color: '#FF9900' }}>care@sahayy.com</a></p>
    </LegalSection>
  </LegalPageLayout>
);

export default PrivacyPolicy;
